import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5170ccf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bubble" }
const _hoisted_2 = { class: "avatar" }
const _hoisted_3 = ["src"]

import { chatEnable } from '@/composables/room/useRoomLayout'
import { IPreviewMessage } from '@/types/interfaces/common.interface'
import { onImageError } from '@/helpers/favicon'
import { PropType, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessagePreview',
  props: {
  newMessage: {
    type: Object as PropType<IPreviewMessage>,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

const displayMessage = (msg: IPreviewMessage) => {
  if (msg.type === 'image') {
    return `${msg.participant.name} sent you an image`
  } else if (msg.type === 'file') {
    return `${msg.participant.name} sent you a file`
  } else {
    return msg.message
  }
}

const messagesStore = ref<IPreviewMessage[]>([])
const clearAllMessages = () => {
  messagesStore.value = []
}

const addNewMessage = (msg: IPreviewMessage) => {
  messagesStore.value.push(msg)
  setTimeout(() => {
    messagesStore.value = messagesStore.value.filter((ms) => ms.id !== msg.id)
  }, 3000)
}

watch(
  () => props.newMessage,
  (msg?: IPreviewMessage) => {
    if (!msg) return
    addNewMessage(msg)
  },
  { deep: true },
)

watch(
  () => chatEnable.value,
  (enable) => {
    if (enable) {
      clearAllMessages()
    }
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_TransitionGroup, {
    name: "message-preview-list",
    tag: "div",
    class: "message-preview"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messagesStore.value, (msg) => {
        return (_openBlock(), _createElementBlock("div", {
          key: msg.id,
          class: "message message-preview-list-item _pointer-on-hover",
          onClick: clearAllMessages
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(displayMessage(msg)), 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: msg.participant.avatar || '',
              draggable: "false",
              onErrorOnce: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onImageError) && _unref(onImageError)(...args)))
            }, null, 40, _hoisted_3)
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})